import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexReactClient } from "convex/react";

import { env } from "../../env";

const convex = new ConvexReactClient(env.VITE_CONVEX_URL);

export default function AppConvexProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <ConvexAuthProvider client={convex}>{children}</ConvexAuthProvider>;
}
